import { gql } from "@apollo/client"

// export type SingleStringValue = {
//   value: string;
// }

export interface Def_MutationResponse {
  code: string;
  success: boolean;
  message: string;
}

// USER FARMS
export const USER_FARMS = gql`
  query Companies {
    user {
      companies {
        company_id
        name
        domain
        legacy
      }
    }
  }
`;

export interface UserFarm_Data {
  company_id: number
  name: string
  domain: string
  legacy: boolean
}

export type UserFarmsArgs = {
  company_id?: number;
}

export interface FarmsResponse {
  user: {
    companies: UserFarm_Data[];
  }
}

// FARM INFO
export const FARM_INFO = gql`
  query FarmInfo($domain: String!) {
    company {
      info(domain: $domain) {
        company_id
        name
        domain
        city
        street
        phone
        vat
        email
      }
    }
  }`;
export interface Farm_Data {
  company_id: number;
  domain: string;
  name: string;
  city: string;
  street: string;
  phone: string;
  vat: string;
  email: string;
}

export type FarmInfoArgs = {
  domain: string;
}
  
export interface FarmInfoResponse {
  company: {
    info: Farm_Data
  }
}

// UPDATE FARM INFO
export const UPDATE_FARM_INFO = gql`
  mutation UpdateInfo($domain: String!, $city: String!, $street: String!, $phone: String!, $vat: String!, $email: String!) {
    company {
      updateInfo(domain: $domain, city: $city, street: $street, phone: $phone, vat: $vat, email: $email) {
        code
        success
        message
      }
    }
  }
`;    

export type UpdateFarmInfoArgs = {
  domain: string;
} & Partial<Farm_Data>
  
export interface UpdateFarmInfoResponse {
  company: {
    updateInfo: Def_MutationResponse;
  }
}